import { Table, useApiQuery, type Column } from 'grabbitbot-legacy-ui'
import { screenerClient } from '../../api'
import type { AdminRecord } from '../../api/types'

/** Equivalent of legacy `AdminUserListComponent` (audit §3/§4 — `GET /admin/users`). */
export function AdminUsersPage() {
  const { data, loading, error } = useApiQuery(() => screenerClient.admin.listUsers(), [])

  const columns: Column<AdminRecord>[] = [
    { key: 'username', label: 'Username', align: 'left' },
    { key: 'createdAt', label: 'Created', align: 'left' },
    { key: 'status', label: 'Status' },
  ]

  return (
    <div>
      <h1>Admin — users</h1>
      {loading && <p>Loading…</p>}
      {error && <p role="alert">Could not load users.</p>}
      {data && <Table columns={columns} rows={data} rowKey={(row, i) => (row.id as string) ?? i} />}
    </div>
  )
}
